import {Module} from 'vuex';

/**
 * 竣工评论数据模块
 * @type {Module}
 */
export const completion = {
    namespaced: true,
    state: {
        // 报告列表
        arrReportList: [
            {
                title: '进场定位交底交付报告',
                status: 2, // 0默认状态  1待确认 2已确认
                userScore: 5, // 用户评分
                userEvaText: '每个机器安装的地方都已示范标准，施工准备工作很认真', // 评论内容
                imageList: ['', '', '', '', ''], // 图像列表
                report_appraise:{},
            },
            {
                title: '空调隐蔽系统施工监理报告',
                status: 1, // 0默认状态  1待确认 2已确认
                imageList: ['', '', '', '', ''], // 图像列表
                report_appraise:{},
                programs: {
                    process: 6, // 工序
                    qcCount: 18, // 质控数
                }
            },
            {
                report_appraise:{},
                title: '系统竣工调试验收报告',
                status: 0, // 0默认状态  1待确认 2已确认
            }
        ],
        // 当前激活的主报告
        sActiveReportId: 1,
        // 主报表切换列表
        arrReportNameList: [
            {
                title: '冷暖风水系统施工交付报告',
                id: 1,
            },
        ],
    },
    mutations: {
        /**
         * 改变激活的主报告id
         * @param state
         * @param typeAction
         * @constructor
         */
        CHANGE_REPORT_ACTIVE_ID(state, typeAction) {
            state.sActiveReportId = typeAction.id;
        }
    },
    actions: {},
    getters: {
        /**
         * 当前激活的主报告
         * @param state
         * @returns {{name: string, id: number} | {name: string, id: number}}
         */
        activeReportName(state) {
            return state.arrReportNameList.find(i => i.id === state.sActiveReportId) ?? {}
        },
    },
}

